import { Metric } from '@models';

export const metrics: { [key: string]: Metric } = {
  time: {
    value: 0,
    unit: 'Second',
    id: 'a4568449-80c3-42f0-abe7-b93bdb9c8964',
  },
  grasperPath: {
    value: 0,
    unit: 'Integer',
    id: '0eb3bebb-8b77-4c19-92c1-369f3b1b8f6f',
  },
  ligatingLoopPath: {
    value: 0,
    unit: 'Integer',
    id: '3edae2a0-1328-4d68-925a-637d6bf880d3',
  },
};
